import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'providersPipe'
})
export class ProvidersSelectPipe implements PipeTransform {
    transform(providers: any, term?: any): any {

        if (term === undefined) return providers;
        if (term === null) return providers;

        if (providers != null) {
            return providers.filter(function (provider) {
                if (provider.name != undefined)
                    if (provider.name.toLowerCase().includes(term.toLowerCase()))
                        return provider;
            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-partial-provider-select/providers-select-pipe.ts